import { RichDescriptionInputMedia } from "@/src/components/RichDescriptionInput";
import { useUploadedImages } from "arkh";
import React, { useMemo } from "react";
import { useMutation, useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { TodoEditNewMainMediaComponentMedia_todo$key } from "./__generated__/TodoEditNewMainMediaComponentMedia_todo.graphql";
import { TodoEditNewMainMediaComponentRemoveImageMutation } from "./__generated__/TodoEditNewMainMediaComponentRemoveImageMutation.graphql";

export function TodoEditNewMainMedia(props: {
  todo: TodoEditNewMainMediaComponentMedia_todo$key;
  highlightCamera: boolean;
}) {
  const [removeImage] =
    useMutation<TodoEditNewMainMediaComponentRemoveImageMutation>(graphql`
      mutation TodoEditNewMainMediaComponentRemoveImageMutation(
        $todoId: ID!
        $imageId: ID!
        $employeeId: ID
      ) {
        todo(todoId: $todoId, employeeId: $employeeId) {
          removeImage(imageId: $imageId) {
            images {
              id
            }
          }
        }
      }
    `);

  const uploadedImages = useUploadedImages();

  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainMediaComponentMedia_todo on Todo {
        id
        canWrite
        isOrg
        images {
          id
          sizes {
            height
            width
          }
          ...LinkedContentInput_images
          ...Image_image
        }
      }
    `,
    props.todo
  );

  const readOnly = !todo.canWrite || todo.isOrg;

  const media = useMemo(() => {
    return [
      ...todo.images.map((i) => {
        const img = uploadedImages.find((a) => a.id === i.id);

        if ((!i.sizes || i.sizes.length === 0) && !img) {
          return null;
        }
        return {
          id: i.id,

          height: i.sizes?.[0]?.height ?? img?.height ?? 1,
          width: i.sizes?.[0]?.width ?? img?.width ?? 1,
          onDelete: readOnly
            ? undefined
            : () => {
                removeImage({
                  variables: {
                    todoId: todo.id,
                    imageId: i.id,
                  },
                });
              },
          image: {
            image: i,
            type: "remote" as const,
          },
        };
      }),
    ].filter((m) => m !== null);
  }, [readOnly, removeImage, todo.id, todo.images, uploadedImages]);

  return <RichDescriptionInputMedia media={media} />;
}
